import React from 'react';
import ChangePasswordForm from './common/ChangePasswordForm';
import deepObj from 'deep-obj';
import axios from 'axios';
import helpers from '../helpers';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react';
import config from '../config';
import { connect } from "react-redux";
import imgCity from './imgs/city.jpg';
import imgLogo from './imgs/login-logo.png';

class ActivationEmailPage extends React.Component {
    constructor(props, context) {
        super(props);

        var uuid = deepObj.get(props, 'location.query.uuid');
        this.state = {
            msg: '',
            type: MessageBarType.error
        };

        if (uuid) {
            axios.post(config.apiUrl + '/auth/active-email', {
                uuid: props.location.query.uuid
            })
            .then(({data}) => {
                this.setState({
                    msg: 'Activation emaill is successful',
                    type: MessageBarType.success
                });
                this.props.dispatch({
                    type: 'setAuth',
                    payload: data
                });
            })
            .catch(err => {
                this.setState({
                    msg: helpers.axiosError(err)
                });
            });
        }
        else {
            this.state = {
                msg: 'uuid is empty'
            }
        }
    }

    dismissMsg() {
        this.setState({
            msg: '',
            type: MessageBarType.error
        });
    }

    render() {
        const { msg, type } = this.state;
        return (
            <div className="ms-Grid">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-u-md8 p0">
                        <img className="vh100 w100p object-fit-cover" src={imgCity} />
                    </div>
                    <div className="ms-Grid-col ms-u-md4 p0">
                        <div className="p20">
                            <div className="p20">
                                <img className="w100p" src={imgLogo} />
                            </div>
                            {msg &&
                                <MessageBar messageBarType={type} onDismiss={() => this.dismissMsg()}>
                                    {msg}
                                </MessageBar>
                            }
                            <ChangePasswordForm />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, own_props) {
  return {
      auth: state.auth
  }
}
export default connect(mapStateToProps)(ActivationEmailPage);


// WEBPACK FOOTER //
// ./client/components/ActivationEmail.js